import i18next from "i18next";
import { Column } from "../objects/column";
import * as locales from 'date-fns/locale';
import { format } from "date-fns";
import { NetworkDirectorListFiltersCriteria } from "../objects/networkDirectorListFiltersCriteria";
import { NetworkDirectorErrors } from "../objects/networkDirectorErrors";
import { NetworkDirectorAgentTableHead } from "../objects/networkDirectorAgentTableHead";
import { NetworkDirectorListConfiguration } from "../objects/networkDirectorListConfiguration";
import { NetworkDirectorListCriteria } from "../objects/networkDirectorListCriteria";


const locales_cpy: { [key: string]: any } = locales;
const domain = window.location.host.split('.')[1];
export const NETWORK_DIRECTOR_MODULE = 'NETWORK_DIRECTOR';
export const NETWORK_DIRECTOR_INFO_ROUTE = '/networkDirector/edit/:id/info';

export const EMPTY_NETWORK_DIRECTOR_FILTERS: NetworkDirectorListFiltersCriteria = {
    name: '',
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
    first_name: "",
    email: ""
};

export const EMPTY_NETWORK_DIRECTOR_ERRORS: NetworkDirectorErrors = {
    last_name_error: "",
    first_name_error: ""
};

export const EMPTY_NETWORK_DIRECTOR_LIST_CRITERIA: NetworkDirectorListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_NETWORK_DIRECTOR_FILTERS,
    search: ''
};

export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'first_name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'username',
    field_name: 'USERNAME',
    checked: false,
    order_by: 'username',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'email',
    field_name: 'EMAIL',
    checked: true,
    order_by: 'email',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'organisation',
    field_name: 'ORGANISATION',
    checked: true,
    order_by: 'client__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'date-joined',
    field_name: 'DATE_JOINED',
    checked: false,
    order_by: 'date_joined',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'email-checked',
    field_name: 'EMAIL_CHECKED',
    checked: true,
    order_by: 'email_checked',
    fixed_width: false,
    last_updated: false,
    width: null
}];

export const MCI_COLUMN: Column[] = [...DEFAULT_COLUMN, {
    label: 'company',
    field_name: 'COMPANY',
    checked: true,
    order_by: 'company',
    fixed_width: false,
    last_updated: false,
    width: null
}];

export const EMPTY_NETWORK_DIRECTOR_LIST_CONFIGURATION: NetworkDirectorListConfiguration = {
    columns: domain === 'tripmci' ? MCI_COLUMN : DEFAULT_COLUMN,
    preferences: []
};


export const NETWORK_DIRECTOR_AGENT_TABLE_HEAD: NetworkDirectorAgentTableHead[] = [
    {
        field_name: "name",
        label: "name",
        sortable: true,
        getValue: (organisation) => `${organisation.name ?? ''}${organisation.street ? ' ,' + organisation.street : ''}${organisation.zip_code? ' ,' + organisation.zip_code : ''}${organisation.city ? ' ,' + organisation.city : ''}${organisation.state ? ' ,' + organisation.state.international_name : ''}`,
    },
    {
        field_name: "created_date",
        label: "created-date",
        sortable: true,
        getValue: (organisation) => organisation.created_date ? format(new Date(organisation.created_date), 'P HH:mm', { locale: locales_cpy[i18next.language.replace("-", "")] }) : '-',
    },
    {
        field_name: "creator",
        label: "created-by",
        sortable: true,
        getValue: (organisation) => organisation.creator ? organisation.creator.username : '-',
    },
    {
        field_name: "modified_date",
        label: "modified-date",
        sortable: true,
        getValue: (organisation) => organisation.modified_date ? format(new Date(organisation.modified_date), 'P HH:mm', { locale: locales_cpy[i18next.language.replace("-", "")] }) : '-',
    },
    {
        field_name: "last_author",
        label: "modified-by",
        sortable: true,
        getValue: (organisation) => organisation.last_author ? organisation.last_author.username : '-'
    }
];

export const HTTP_HEADER = {
    'Authorization': `Token ${localStorage.getItem('token')}`,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': 'fr'
};